"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.lightTheme = void 0;
var material_1 = require("@mui/material");
var colors_1 = require("@mui/material/colors");
var labelTextColor = 'rgba(0,0,0,0.5)';
exports.lightTheme = (0, material_1.createTheme)({
    palette: {
        mode: 'light',
        primary: {
            light: '#d8e2f8',
            main: '#0367D9',
            dark: '#25487c',
            contrastText: '#fff',
        },
        secondary: {
            light: '#bababa',
            main: '#838383',
            dark: '#232323',
            contrastText: '#fff',
        },
        success: {
            light: '#00a861',
            main: '#29A36F',
            dark: '#11c87b',
            contrastText: '#10b670',
        },
        info: {
            light: '#57aae8',
            main: '#02d8d1',
            dark: '#AECCF1',
        },
        error: {
            main: '#F44336',
        },
        grey: {
            '50': '#f5f7fc',
            '600': '#707070',
        },
        common: {
            white: 'rgba(255, 255, 255, 0.96)',
        },
        action: {
            active: '#0465D8',
            hover: '#f5f7fb57',
            hoverOpacity: 0.01,
            selected: '#00000008',
        },
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: 'standard',
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '24px',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    color: '#000000',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    ':before': {
                        borderBottom: '1px solid rgb(0 0 0 / 23%)',
                    },
                    ':hover:not(.Mui-disabled):before': {
                        borderBottom: '2px solid rgba(3, 103, 217, .5)',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                shrink: {
                    fontWeight: 500,
                    lineHeight: 1.8,
                    fontSize: '1rem',
                    letterSpacing: '0.15px',
                    color: labelTextColor,
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: labelTextColor,
                    fontWeight: 500,
                    letterSpacing: '0.15px',
                },
                asterisk: {
                    color: '#0367D9',
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginBottom: -24,
                    marginTop: 2,
                },
            },
        },
    },
    typography: {
        fontFamily: '"Roboto Flex", "Helvetica", "Arial", sans-serif',
        htmlFontSize: 18,
        h1: {
            fontWeight: 400,
            fontSize: '1.7rem',
        },
        h2: {
            fontWeight: 400,
            fontSize: '1.5rem',
        },
        h3: {
            fontWeight: 500,
            fontSize: '1.2rem',
            textTransform: 'unset',
        },
        h4: {
            fontWeight: 200,
            fontSize: '1.2rem',
        },
        h5: {
            fontWeight: 500,
            fontSize: '1rem',
            textTransform: 'uppercase',
            lineHeight: '2rem',
            paddingBottom: '16px',
        },
        h6: {
            fontWeight: 200,
            fontSize: '1rem',
            textTransform: 'unset',
        },
        overline: {
            color: labelTextColor,
            fontSize: '0.75rem',
            textTransform: 'capitalize',
            fontWeight: 600,
            lineHeight: 1.8,
        },
    },
});
exports.darkTheme = (0, material_1.createTheme)({
    palette: {
        mode: 'dark',
        primary: {
            main: colors_1.pink['A200']
        },
        secondary: {
            main: colors_1.cyan['A400']
        },
        background: {
            default: colors_1.blueGrey['800'],
            paper: colors_1.blueGrey['700']
        }
    }
});
